// relocateBoxThunk.ts

import { ThunkAction } from "redux-thunk";
import { AnyAction } from "redux";
import { AppDispatch, RootState } from "../storeConfig";
import { addMessage, MessageType, RestockReason } from "../reducers/responseMessagesReducer";
import { conveyorBoxEndpoints } from "../../conveyorbox/endpoints";
import { setMissingBoxItem } from "../reducers/conveyorBoxReviewReducer";
import { PayloadWrapper } from "../types/PayloadWrapper";
import {
  IConveyorBoxUI,
  IRestockItemUI,
  UpdatePickedQuantityPayload,
} from "../../interfaces/ConveyorBox/IConveyorBox";
import { setRestockItems } from "../reducers/restockReducer";
import { triggerForcedRestockStage } from "../reducers/globalStateReducer";
import { LIMA_WORKSTATIONS } from "../../../utils/Constants";
import * as UtilMethods from "../../../utils/UtilMethods";

export const cancelBoxThunk = () => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();
    const conveyorBox: IConveyorBoxUI = state.conveyorBoxReviewReducer;
    const currentBarcode = conveyorBox.boxBarcode;
    let workstationId = UtilMethods.getParamValue("ws");

    try {
      await conveyorBoxEndpoints.cancelOrder(currentBarcode);
      if ([LIMA_WORKSTATIONS["VBG-CHK-RX"]].includes(parseInt(workstationId))) {
        const restockItems: IRestockItemUI[] = conveyorBox.items.active
          .filter((i) => !i.attributes.includes("RXBAG") && i.pickedQuantity > 0)
          .map((i) => {
            return {
              id: i.id,
              article: i.article,
              sku: i.sku,
              quantity: i.pickedQuantity,
              quantityVerified: 0,
              attributes: i.attributes,
              varunummer: i.varunummer,
              forcedShelfPrefix: "",
              operatorAssignedShelf: "",
              isRestocked: false,
              restockReason: RestockReason.CANCELLATION,
            };
          });

        dispatch(setRestockItems(restockItems));
        dispatch(triggerForcedRestockStage());
      }

      dispatch(
        addMessage({
          messageType: MessageType.SUCCESS,
          title: currentBarcode,
          content: "Ordern avbruten..",
        })
      );
    } catch (error: any) {
      console.error(error);

      dispatch(
        addMessage({
          messageType: MessageType.ERROR,
          title: currentBarcode,
          content: error.message ?? "Något gick fel när ordern skulle avbrytas.",
        })
      );
    }
  };
};

export const confirmExcessPickThunk = (itemId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();
    const conveyorBox = state.conveyorBoxReviewReducer;
    const currentBarcode = conveyorBox.boxBarcode;

    try {
      await conveyorBoxEndpoints.confirmExcessPick(currentBarcode, itemId);
      const items = [...conveyorBox.items.active];
      console.log("🚀 ~ return ~ items:", items);

      const itemIndex = items.findIndex((item) => item.id === itemId);
      if (itemIndex === -1) return;

      const updatedItem = { ...items[itemIndex] };
      updatedItem.pickedQuantity = updatedItem.confirmedQuantity;
      console.log("🚀 ~ return ~ updatedItem:", updatedItem);

      items.splice(itemIndex, 1, updatedItem);
      dispatch(setMissingBoxItem(new PayloadWrapper(items)));
    } catch (error: any) {
      console.error(error);

      dispatch(
        addMessage({
          messageType: MessageType.ERROR,
          title: currentBarcode,
          content: error.message ?? "Något gick fel vid bekräftelse av överplock...",
        })
      );
    }
  };
};

export const increasePickedQuantityThunk = (
  itemId: number
): ThunkAction<Promise<void>, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const state = getState();
    const conveyorBox = state.conveyorBoxReviewReducer;
    const currentBarcode = conveyorBox.boxBarcode;

    try {
      await conveyorBoxEndpoints.confirmExcessPick(currentBarcode, itemId);
      const items = [...conveyorBox.items.active];
      console.log("🚀 ~ return ~ items:", items);

      const itemIndex = items.findIndex((item) => item.id === itemId);
      if (itemIndex === -1) return;

      const updatedItem = { ...items[itemIndex] };
      updatedItem.pickedQuantity = updatedItem.confirmedQuantity;
      console.log("🚀 ~ return ~ updatedItem:", updatedItem);

      items.splice(itemIndex, 1, updatedItem);
      dispatch(setMissingBoxItem(new PayloadWrapper(items)));
    } catch (error: any) {
      console.error(error);

      dispatch(
        addMessage({
          messageType: MessageType.ERROR,
          title: currentBarcode,
          content: error.message ?? "Något gick fel vid bekräftelse av överplock...",
        })
      );
    }
  };
};

export const updatePickedQuantityThunk = (
  payload: UpdatePickedQuantityPayload
): ThunkAction<Promise<void>, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const state = getState();
    const conveyorBox = state.conveyorBoxReviewReducer;
    const currentBarcode = conveyorBox.boxBarcode;

    try {
      await conveyorBoxEndpoints.updatePickedQuantity(currentBarcode, payload);

      const items = [...conveyorBox.items.active];
      console.log("🚀 ~ return ~ items:", items);

      const itemIndex = items.findIndex((item) => item.id === payload.itemId);
      if (itemIndex === -1) return;

      const updatedItem = { ...items[itemIndex] };
      if (payload.action === "Increase") {
        updatedItem.pickedQuantity += payload.quantity;
      } else {
        updatedItem.pickedQuantity -= payload.quantity;
      }
      console.log("🚀 ~ return ~ updatedItem:", updatedItem);

      items.splice(itemIndex, 1, updatedItem);
      dispatch(setMissingBoxItem(new PayloadWrapper(items)));
    } catch (error: any) {
      console.error(error);

      dispatch(
        addMessage({
          messageType: MessageType.ERROR,
          title: currentBarcode,
          content: error.message ?? "Något gick fel vid bekräftelse av överplock...",
        })
      );
    }
  };
};
